import { render, staticRenderFns } from "./StructureList.vue?vue&type=template&id=2da9f604&scoped=true"
import script from "./StructureList.vue?vue&type=script&lang=js"
export * from "./StructureList.vue?vue&type=script&lang=js"
import style0 from "./StructureList.vue?vue&type=style&index=0&id=2da9f604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da9f604",
  null
  
)

export default component.exports